module.exports = __webpack_public_path__ + "img/title-bg.27efdda2.png";